import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/auth";
import { useNavigate, useLocation } from "react-router-dom";
import OnboardingPage from "./OnboardingPage";
import SignUp from "./SignUp";
import OtpModal from "../Modals/OtpModal";
import ProfilePicturePage from "./ProfilePicturePage";
import WelcomeModal from "../Modals/welcomeModal/WelcomeModal";

const OnboardingFlow = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState("onboarding");
  const [selectedRole, setSelectedRole] = useState(
    location.state?.role || "host"
  );
  const [userData, setUserData] = useState(null);
  const [inviteCode, setInviteCode, hostId] = useState(
    location.state?.inviteCode || null
  );
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(false);
  const { user, setUser } = useContext(AuthContext);

  useEffect(() => {}, [currentStep, selectedRole, userData]);

  const handleOnboardingComplete = (data = {}) => {
    if (data.inviteCode) {
      setInviteCode(data.inviteCode);
    }
    setCurrentStep("signup");
  };

  const handleSignUpComplete = (formData) => {
    const updatedUserData = { ...formData, role: selectedRole, inviteCode };
    setUserData(updatedUserData);
    setUser({
      ...user,
      userId: formData.userId || user.userId || "",
      firstName: formData.firstName || user.firstName || "",
      lastName: formData.lastName || user.lastName || "",
      email: formData.email || user.email || "",
      phoneNumber: formData.phoneNumber || user.phoneNumber || "",
      role: [selectedRole],
    });
    setIsOtpModalOpen(true);
  };

  const handleOtpVerify = (code, method) => {
    setIsOtpModalOpen(false);
    setCurrentStep("profile-picture");
  };

  const handleProfileComplete = () => {
    setCurrentStep("complete");
    setIsWelcomeModalOpen(true);
  };

  const handleWelcomeComplete = (action) => {
    setIsWelcomeModalOpen(false);
    const fullName = `${userData?.firstName || user?.firstName || ""} ${
      userData?.lastName || user?.lastName || ""
    }`.trim();
    const userInfo = {
      userId: user?.userId || userData?.userId || "",
      firstName: userData?.firstName || user?.firstName || "",
      lastName: userData?.lastName || user?.lastName || "",
      email: userData?.email || user?.email || "",
      phoneNumber: userData?.phoneNumber || user?.phoneNumber || "",
      role: [selectedRole],
    };
    if (action === "createEvent") {
      navigate("/home/host", {
        state: { userName: fullName, user: userInfo },
      });
    } else if (action === "joinEvent") {
      navigate("/invites", { state: { userName: fullName, user: userInfo } });
    } else {
      navigate(selectedRole === "guest" ? "/home/guest" : "/home/host", {
        state: { userName: fullName, user: userInfo },
      });
    }
  };

  return (
    <>
      {currentStep === "onboarding" && (
        <OnboardingPage
          onContinue={handleOnboardingComplete}
          selectedRole={selectedRole}
          onRoleChange={setSelectedRole}
        />
      )}

      {currentStep === "signup" && (
        <SignUp
          onSubmit={handleSignUpComplete}
          onBack={() => setCurrentStep("onboarding")}
          selectedRole={selectedRole}
          inviteCode={inviteCode}
        />
      )}

      {isOtpModalOpen && (
        <OtpModal
          visible={isOtpModalOpen}
          email={userData?.email || ""}
          phoneNumber={userData?.phoneNumber || ""}
          userId={userData?.userId || user?.userId || ""}
          selectedRole={selectedRole}
          onClose={() => setIsOtpModalOpen(false)}
          onVerify={handleOtpVerify}
          onResend={() => console.log("Resend OTP")}
          onEditEmail={() => setCurrentStep("signup")}
          onEditPhone={() => setCurrentStep("signup")}
        />
      )}

      {/* {currentStep === "complete" && (
        <WelcomeModal
          isOpen={isWelcomeModalOpen}
          onClose={() => handleProfileComplete()}
          userName={`${userData?.firstName || user?.firstName || ""} ${
            userData?.lastName || user?.lastName || ""
          }`.trim()}
          inviteCode={inviteCode}
          hostId={hostId}
          role={selectedRole}
          buttons={{
            primary:
              selectedRole === "guest" ? "Proceed to Events" : "Create Event",
            primaryAction: () =>
              handleWelcomeComplete(
                selectedRole === "guest" ? "joinEvent" : "createEvent"
              ),
            secondary: selectedRole === "host" ? "Home" : null,
            secondaryAction: handleWelcomeComplete,
          }}
        />
      )} */}

      {currentStep === "profile-picture" && (
        <ProfilePicturePage
          onProceed={handleProfileComplete}
          onBack={() => setCurrentStep("signup")}
          selectedRole={selectedRole}
          userData={userData}
          source="ONBOARDING"
        />
      )}
    </>
  );
};

export default OnboardingFlow;
